import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=6117ee34&"
import script from "./Projects.vue?vue&type=script&lang=ts&"
export * from "./Projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports